import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, TrainIcon, CarIcon, ExternalLinkIcon } from 'lucide-react';
const MAP_URL = 'https://mapy.com/cs/turisticka?planovani-trasy&rc=9hOj9xXGb0&rs=&rs=coor&ri=&ri=&mrp=%7B%22c%22%3A111%2C%22dt%22%3A%22%22%2C%22d%22%3Atrue%7D&xc=%5B%5D&rut=1&x=14.5184141&y=49.9449350&z=17';
export function LocationSection() {
  return <section id="lokalita" className="py-24 bg-white overflow-hidden" data-id="element-155">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-156">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-157">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-158">
            <div className="flex items-center gap-3 text-accent mb-4" data-id="element-159">
              <MapPinIcon className="w-5 h-5" data-id="element-160" />
              <span className="font-medium tracking-wider uppercase text-sm" data-id="element-161">
                Dolní Jirčany, Praha-západ
              </span>
            </div>
            <h2 className="font-heading text-4xl md:text-5xl text-primary mb-6" data-id="element-162">
              Lokalita
            </h2>

            <div className="space-y-6 text-base-gray text-lg mb-10" data-id="element-163">
              <p data-id="element-164">
                Projekt se nachází ve strategické a vyhledávané lokalitě, která
                kombinuje klid venkova s výbornou dostupností do metropole.
              </p>
              <ul className="space-y-[5px]" data-id="element-165">
                <li className="flex items-start gap-3" data-id="element-166">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" data-id="element-167" />
                  <span data-id="element-168">Pražský okruh ca 2 km</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-169">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" data-id="element-170" />
                  <span data-id="element-171">Metro Opatov 12 km</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-172">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" data-id="element-173" />
                  <span data-id="element-174">
                    Nákupní zóna Čestlice / Aquapalace, hypermarkety 13 km
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-175">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" data-id="element-176" />
                  <span data-id="element-177">Zámek a park Průhonice 15 km</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-178">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" data-id="element-179" />
                  <span data-id="element-180">Autobusové zastávky PID v docházkové vzdálenosti</span>
                </li>
              </ul>

              <div className="pt-4 border-t border-primary/10" data-id="element-181">
                <h4 className="font-heading text-xl text-base-dark mb-4" data-id="element-182">
                  Kompletní občanská vybavenost
                </h4>
                <ul className="space-y-4 text-base" data-id="element-183">
                  <li className="flex items-start gap-3" data-id="element-184">
                    <div className="w-2 h-2 rounded-full bg-accent mt-2 flex-shrink-0" data-id="element-185" />
                    <span data-id="element-186">
                      <strong data-id="element-187">Přímo v objektu:</strong> supermarket s plochou 1
                      000 m² (24/7/365), další obchody, lékárna, lékařské
                      ordinace, sauna/masáže, fitness
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-188">
                    <div className="w-2 h-2 rounded-full bg-accent mt-2 flex-shrink-0" data-id="element-189" />
                    <span data-id="element-190">
                      <strong data-id="element-191">V okruhu stovek metrů:</strong> pošta, bankomat,
                      obecní úřad, nová ZŠ, školky, autobusové zastávky PID,
                      sportovní zázemí – temperovaná tenisová hala, tělocvičny,
                      2 travnatá fotbalová hřiště, lesopark, rybník
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-192">
                    <div className="w-2 h-2 rounded-full bg-accent mt-2 flex-shrink-0" data-id="element-193" />
                    <span data-id="element-194">
                      <strong data-id="element-195">V okruhu jednotek km:</strong> multifunkční
                      sportovní hala Hlubočinka 3 km, SUNNY Canadian
                      MŠ/ZŠ/Gymnázium 5 km, Da VINCI school – Dolní Břežany 7
                      km, IKEM Praha 10 km, Prague British International School
                      10 km, přírodní i kryté jízdárny
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="flex flex-wrap gap-4" data-id="element-196">
              <div className="flex items-center gap-2 bg-base-cream px-4 py-2 rounded-full text-sm font-medium text-primary" data-id="element-197">
                <CarIcon className="w-4 h-4" data-id="element-198" />
                Pražský okruh - 2 km
              </div>
              <div className="flex items-center gap-2 bg-base-cream px-4 py-2 rounded-full text-sm font-medium text-primary" data-id="element-199">
                <TrainIcon className="w-4 h-4" data-id="element-200" />
                Metro Opatov - 12 km
              </div>
              <div className="flex items-center gap-2 bg-base-cream px-4 py-2 rounded-full text-sm font-medium text-primary" data-id="element-201">
                <MapPinIcon className="w-4 h-4" data-id="element-202" />
                Aquapalace Čestlice - 13 km
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative h-[500px] w-full bg-base-cream rounded-2xl border border-primary/10 flex items-center justify-center p-8 overflow-hidden shadow-xl" data-id="element-203">
            {/* Background Image */}
            <img src="https://cdn.magicpatterns.com/uploads/pBPDF5SFGUcvhqAVU9DGHy/18.png" alt="Nádvoří Svatý Václav" className="absolute inset-0 w-full h-full object-cover" data-id="element-204" />

            {/* Overlay to ensure card readability */}
            <div className="absolute inset-0 bg-primary/10" data-id="element-205"></div>

            {/* Stylized Map Placeholder Pattern */}
            <div className="absolute inset-0 opacity-20 mix-blend-multiply" style={{
            backgroundImage: 'radial-gradient(#4A4543 1px, transparent 1px)',
            backgroundSize: '20px 20px'
          }} data-id="element-206"></div>

            <div className="relative z-10 bg-white/95 backdrop-blur-sm p-8 rounded-xl shadow-2xl max-w-sm text-center border-t-4 border-primary" data-id="element-207">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-208">
                <MapPinIcon className="w-8 h-8 text-primary" data-id="element-209" />
              </div>
              <h3 className="font-heading text-2xl font-bold text-base-dark mb-2" data-id="element-210">
                Svatý Václav
              </h3>
              <p className="text-base-gray mb-4" data-id="element-211">
                Dolní Jirčany
                <br data-id="element-212" />
                Praha-západ
              </p>
              <div className="h-px w-full bg-gray-100 my-4" data-id="element-213" />
              <a href={MAP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-accent hover:text-accent-hover font-medium transition-colors" data-id="element-214">
                Zobrazit na mapě
                <ExternalLinkIcon className="w-4 h-4" data-id="element-215" />
              </a>
            </div>

            {/* Decorative elements */}
            <div className="absolute top-10 right-10 w-32 h-32 bg-primary/20 rounded-full blur-2xl" data-id="element-216"></div>
            <div className="absolute bottom-10 left-10 w-40 h-40 bg-accent/20 rounded-full blur-2xl" data-id="element-217"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}